import React from 'react';
import { Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';

function HowItWorks() {

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10">
          <div className="content-section">
            <h1>Hur det fungerar</h1>
            <p>Laddvis-appen laddar du hem som vanligt till din Android eller iPhone via respektive app store.</p>
            <p>Laddvis förutsätter att du har ett elavtal med kvartspriser. Med ett sådant avtal så varierar priset för din el varje kvart. 
              Ibland är det biligare och ibland är det dyrare och priserna görs tillgängliga i förväg för nästkommande dygn. 
              Genom att räkna ut hur många kWH din bil behöver laddas med, vilken effekt du vill ha på laddningen och elpriset över dygnets kan vi se till
               så att laddningen sker när det är som allra billigast. Om ditt elnätsbolag har gått över på effekttaxa så kan du enkelt beskriva tiderna för
               höglast och sen ser Laddvis till att inte ladda bilen under de timmarna</p>
            <p>Inför varje ny laddning behöver du bara ange bilens batterinivå och när du vill att laddningen ska vara klar så sköter appen resten! 
              Om du alltid laddar bilen under samma förutsättningar så behöver du inte göra mer än att koppla in laddkabeln i din bil så skapar Laddvis upp ett nytt schema helt automatiskt.</p>
          </div>

          <div className="content-section">
            <h1>Kom igång</h1>
            <p>Första steget för att komma igång är såklart att ladda hem appan via Google Play Store eller Apple App Store.</p>
            <p>Efter att du installerat appen följer du bara guiden för att komma igång. Guiden hjälper dig med att ansluta till din laddbox, att ange elområde och att ställa in uppgifter om din bil så som batterikapacitet.</p>
          </div>

          <div className="content-section">
            <h1>Förutsättningar</h1>
            <p>Laddvis finns både för Android och iPhone</p>
            <p>Easee Laddbox krävs. Har du en annan laddbox och du vill använda appen så vill vi gärna att du kontaktar oss.</p>
            <p>Kvartsprisavtal med din elleverantör är en förutsättning för att du ska spara som mest pengar.</p>
          </div>

          <div className="content-section">
            <h2>Vanliga frågor</h2>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>Vilka mobiler fungerar appen på?</Accordion.Header>
                <Accordion.Body>
                  Alla Android-telefoner och alla iPhones.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>Vilka laddboxar har ni stöd för?</Accordion.Header>
                <Accordion.Body>
                  Easees laddboxar. Vi jobbar på att lägga till stöd för fler. Om du vill använda appen med en annan laddbox så maila oss gärna på info@laddvis.se och berätta vilken.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Vilket elavtal ska jag ha för att kunna använda appen?</Accordion.Header>
                <Accordion.Body>
                  Du behöver ha ett kvartsprisavtal för att kunna dra nytta av appen. Det innebär att du får ett pris för varje kvart. Det finns flera el-leverantörer på marknaden som erbjuder den typen av avtal.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Vad kostar det?</Accordion.Header>
                <Accordion.Body>
                  Första 30 dagarna är gratis. Därefter kostar appen 29kr i månaden.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Vilka bilmodeller stöds i appen?</Accordion.Header>
                <Accordion.Body>
                  Alla bilmodeller som kan laddas med Easee-laddare stöds. Du anger bara själv bilens batterikapacitet och laddningseffekt en gång i inställningarna. Samt att du inför varje laddning anger aktuell laddningsnivå i batteriet.          
                </Accordion.Body>
              </Accordion.Item>      
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
